export default __webpack_public_path__ + "static/media/customizationIcon.4bdbe42f.svg";